<ng-container *ngIf="status$ | async">
  <div
    class="js-container-search-modal container-search-box-modal"
    (click)="closeByContainer($event)"
    (keyup.escape)="close()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="search-modal-title"
  >
    <div class="search-container">
      <div class="container">
        <form [formGroup]="searchForm" (submit)="submit()" role="search">
          <div class="row">
            <div class="col-12">
              <h2 id="search-modal-title" class="visually-hidden">Modal de Busca</h2>
              <div class="input-group">
                <div class="search-input-container">
                  <label for="search" class="visually-hidden">Termo de busca</label>
                  <input
                    id="search"
                    type="text"
                    class="js-search form-control"
                    formControlName="search"
                    [placeholder]="'searchable.placeholder.products' | translate"
                    autocomplete="off"
                    (input)="onSearch($event)"
                    role="combobox"
                    [attr.aria-expanded]="(productResults$.value?.products?.length ?? 0) > 0"
                    [attr.aria-describedby]="(productResults$.value?.products?.length ?? 0) > 0 ? 'search-results' : null"
                    [attr.aria-controls]="(productResults$.value?.products?.length ?? 0) > 0 ? 'search-results' : null"
                  />
                  <span class="spinner" *ngIf="loading"></span>

                  <button *ngIf="!loading" type="submit" class="search-button" aria-label="Executar busca">
                    <span class="icon material-symbols-outlined">search</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div id="search-results" role="region" aria-label="Resultados da busca">
          <!-- Resultados de Produtos -->
          <ng-container *ngIf="productResults$ | async as products">
            <div class="results-header" *ngIf="products.suggestions.length > 0 || products.didYouMean">
              <span class="results-title">Termos sugeridos</span>
              @if (products.suggestions.length > 0) {
                <ul class="js-results results has-suggestion" role="listbox" aria-label="Produtos sugeridos">
                  <li
                    *ngFor="let suggestion of products.suggestions; trackBy: trackBySuggestion"
                    role="option"
                    tabindex="0"
                    [attr.aria-selected]="false"
                  >
                    <a
                      href="javascript:void(0)"
                      (click)="navigateToSuggestion(suggestion); $event.stopPropagation()"
                      (keyup.enter)="navigateToSuggestion(suggestion)"
                      (keyup.space)="navigateToSuggestion(suggestion)"
                      tabindex="0"
                      role="button"
                    >
                      <div class="details">
                        <span class="material-symbols-outlined result-icon">search</span>
                        <span class="result-text">{{ suggestion }}</span>
                      </div>
                    </a>
                  </li>
                </ul>
              } @else {
                <ul class="js-results results has-suggestion" *ngIf="products.didYouMean" role="listbox" aria-label="Produtos sugeridos">
                  <li role="option" tabindex="0" [attr.aria-selected]="false">
                    <a
                      href="javascript:void(0)"
                      (click)="navigateToSuggestion(products.didYouMean); $event.stopPropagation()"
                      (keyup.enter)="navigateToSuggestion(products.didYouMean)"
                      (keyup.space)="navigateToSuggestion(products.didYouMean)"
                      tabindex="0"
                      role="button"
                    >
                      <div class="details">
                        <span class="material-symbols-outlined result-icon">search</span>
                        <span class="result-text">{{ products.didYouMean }}</span>
                      </div>
                    </a>
                  </li>
                </ul>
              }
            </div>

            <div class="results-header" *ngIf="products.products.length > 0">
              <span class="results-title">Produtos sugeridos</span>
              <ul
                class="js-results results"
                [ngClass]="{ 'has-products': products.products.length }"
                role="listbox"
                aria-label="Produtos encontrados"
              >
                <li li *ngFor="let product of products.products; trackBy: trackByProductCode" role="option" [attr.aria-selected]="false">
                  <a
                    href="javascript:void(0)"
                    (click)="navigateToProduct(product); $event.stopPropagation()"
                    (keyup.enter)="navigateToProduct(product)"
                    (keyup.space)="navigateToProduct(product)"
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="'Navegar para produto ' + product.description"
                  >
                    <div class="box-img">
                      <cx-media [media]="imageProduct(product)" (mediaError)="onImageError($event)" />
                    </div>
                    <div class="details">
                      <p class="name">{{ product.name }}</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </ng-container>
          <!-- Mensagem de "Nenhum resultado encontrado" -->
          <ng-container *ngIf="showNoResults">
            <div class="no-results" role="status" aria-live="polite">
              <span class="material-symbols-outlined">search</span>
              <p>Nenhum resultado encontrado</p>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
